import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n';
import ReactHtmlParser from 'html-react-parser';

import Button from '../../UI/Buttons/Button';
import { getFormattedDate } from '../../Utilities/HelperFunctions';
export function ThankyouPage(props) {

    const { t, i18n } = useTranslation();
    const {handlePageChange, 
        isDiscountApplied,
        prevPrice,
        showAddedTax,
        currencySymbol,
        frequencyText,
        subsName,
        startDate,
        endingDate,
        userName,
        prevPriceValue,
        frequencyInMonths,
        freqDescription
       } = props;
   
    
    const handleRedirection = () => {
        let returnUrl = sessionStorage.getItem("ReturnUrl");
        window.location.href = returnUrl;
    }
 
    return (
        <div className="container  center-text ">

            <div className="item-container">
                <h1 class="block-header" tabindex="-1">{format(t("retentionoffer.thankyoutext"), userName)} </h1>
            </div>

            <div className="item-container">
                <div className="item-wrapper">
                    <p className="small-text">{t("retentionoffer.subscriptionendingtext")} </p>
                    <p className="xxlarge"> <strong>{endingDate}</strong>.</p>
                </div>
            </div>

           <div className="item-container">
                <div className="border-seperator"></div>
            </div>

            <div className="item-container ">
                <div className="item-wrapper" >

                    <p>{t("retentionoffer.newsubscriptiontext")}</p>
                    <p class="large"><strong>{subsName}</strong> </p>

                    {isDiscountApplied ? <p>{frequencyText}</p> : 
                    <strong>{prevPriceValue}{freqDescription}{showAddedTax && <p>{t('retentionoffer.addedtaxstring')}</p>}</strong> }
                </div>
                        
                <div className="item-container">
                   <div class="item-wrapper">
                     <p class="small-text">{t("retentionoffer.startdatelabel")}</p>
                     <p class="large"><strong>{startDate}</strong> </p>
                  </div>
               </div>

               <div className="item-container">
                <div className="item-wrapper center-flex-row">
                    <Button type="button" buttonSize="medium" onClick={()=>{handleRedirection()}}>{t('retentionoffer.backtohomepagebuttontext')}</Button>
                </div>
            </div>
             
            </div>
        </div>

    );
}